<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";

defineEmits<{ close: [] }>();
</script>

<template>
  <div
    class="relative px-4 py-6 border-b border-neutral300 h500 text-neutral1000"
  >
    <div class="h-6 flex items-center justify-center">
      <slot></slot>
    </div>
    <div class="absolute top-0 right-4 h-full flex flex-col justify-center">
      <button
        type="button"
        class="p-3 focus-visible-strong rounded hover:bg-neutral100 transition-colors"
        :aria-label="$t('global.close')"
        @click.stop="$emit('close')"
      >
        <SVG icon="far-xmark" height="1.5rem" width="1.5rem" />
      </button>
    </div>
  </div>
</template>
